import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaSpinner, FaTimes } from 'react-icons/fa';
import { CloseIcon, SettingsInterestIcon } from 'ui-component/custom-icons/icons';
import toast from 'react-hot-toast';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const InterestModal = ({ openPopup, details, handleClose, handleReloadList }) => {
    const [information, setInformation] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isFormProcessing, setIsFormProcessing] = useState(false);
    const isMobile = useIsMobile();

    useEffect(() => {
        setInformation({
            id: details?.id,
            name: details?.name,
        });
        setIsDataLoaded(true);
        // eslint-disable-next-line
    }, [details, openPopup]);

    const handleProcessSubmit = () => {
        setIsFormProcessing(true);
        if (!information?.name) {
            toast.error('Interest is required');
            setIsFormProcessing(false);
            return false;
        }
        if (!information?.id) {
            toast.promise(
                api.settingsCreateInterest(information).then((res) => {
                    if (res.status) handleReloadList();
                    return res?.status === true ? res : null;
                }),
                {
                    loading: 'Creating interest...',
                    success: (data) => `${data.message}`,
                    error: <b>Creating interest Failed</b>
                }
            ).finally(() => setIsFormProcessing(false));
        } else {
            toast.promise(
                api.settingsUpdateInterest(information).then((res) => {
                    if (res.status) handleReloadList();
                    return res?.status === true ? res : null;
                }),
                {
                    loading: 'Updating interest...',
                    success: (data) => `${data.message}`,
                    error: <b>Updating interest failed</b>
                }
            ).finally(() => setIsFormProcessing(false));
        }
    };

    const handleProcessEnter = (event) => {
        if (event.key === 'Enter') {
            handleProcessSubmit();
        }
    };

    if (!openPopup) return null;

    if (isMobile) {
        return (
            <div
                className="d-flex"
                style={{
                    width: '100vw',
                    height: '100dvh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    zIndex: 20,
                    background: 'rgba(0,0,0,0.07)',
                    justifyContent: 'center',
                    alignItems: 'end',
                    paddingBottom: '90px',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)'
                }}
            >
                <div
                    className="popup interest-popup-mobile d-md-none"
                    style={{
                        position: 'relative',
                        transform: 'none',
                        top: 0,
                        left: 0,
                        maxWidth: '90%',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                        width: '100%',
                        padding: '24px 16px 0 16px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <SettingsInterestIcon height={'36px'} width={'36px'} />
                            <span style={{ fontWeight: 600, fontSize: 18 }}>Interest</span>
                        </div>
                        <button className="btn modal-close-icon" onClick={handleClose} style={{ background: 'none', border: 'none', padding: 0 }}>
                            <FaTimes size={18} />
                        </button>
                    </div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 18 }}>
                        Manage your customer interests to tailor your products and services.
                    </div>
                    <div className="form-group" style={{ marginBottom: 18 }}>
                        <input
                            type="text"
                            className="form-control"
                            value={information?.name || ''}
                            placeholder="Enter interest"
                            onChange={(e) => setInformation({ ...information, name: e.target.value })}
                            onKeyDown={handleProcessEnter}
                        />
                    </div>
                    {/* Sticky bottom buttons */}
                    <div
                        className="btnarea"
                        style={{
                            position: 'sticky',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            background: '#fff',
                            padding: '16px 0 12px 0',
                            zIndex: 30,
                            display: 'flex',
                            gap: 10,
                            justifyContent: 'center',
                            marginTop: 'auto'
                        }}
                    >
                        <button
                            className="btn btn-main"
                            disabled={!isDataLoaded || isFormProcessing}
                            onClick={() => {
                                if (!isFormProcessing) handleProcessSubmit();
                            }}
                        >
                            {isFormProcessing ? (
                                <>
                                    <FaSpinner className="fa-spin" /> Saving...
                                </>
                            ) : (
                                <>
                                    <FaSave /> Save
                                </>
                            )}
                        </button>
                        <button className="btn new-btn-error" onClick={handleClose}>
                            <FaTimes /> Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Desktop version (Modal)
    return (
        <Modal show={openPopup} centered size="sm">
            <Modal.Body>
                <div className="p-2">
                    <div style={{ padding: '20px' }}>
                        <div className="mb-2 ml-0 pl-0">
                            <div className="row">
                                <div className="col-12 text-center color-theme">
                                    <SettingsInterestIcon height={'60px'} width={'60px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>
                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 20px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Interest
                                </div>
                                <div className='textGray'>
                                    Manage your customer interests to tailor your products and services.
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top" style={{ padding: '3px 0' }}>
                            <div className="col-12 form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputName"
                                    value={information?.name || ''}
                                    placeholder="Enter interest"
                                    onChange={(e) => {
                                        setInformation({
                                            ...information,
                                            name: e.target.value
                                        })
                                    }}
                                    onKeyDown={handleProcessEnter}
                                />
                            </div>
                        </div>
                        <div className="row align-items-top mt10" style={{ padding: '3px 0' }}>
                            <div className="col-12">
                                <button
                                    type="button"
                                    className="btn-block btn-primary btn-outlined-main-primary  white-var"
                                    disabled={!isDataLoaded || isFormProcessing}
                                    onClick={() => {
                                        if (!isFormProcessing) {
                                            handleProcessSubmit()
                                        }
                                    }}
                                    style={{ lineHeight: '25px' }}
                                >
                                    {
                                        isFormProcessing ? (
                                            <>
                                                <FaSpinner className="fa-spin" /> Saving...
                                            </>
                                        ) : (
                                            <>
                                                <FaSave /> Save
                                            </>
                                        )
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InterestModal;
